import Container from "@components/Atomic/Container/Container";
import { Image } from "@components/Image/Image";
import ImageContent from "@components/ImageContent";
import { StyledContainer } from "@components/Styled/Container";
import React, { Suspense, lazy } from "react";
import SwiperCore, { Pagination } from "swiper";
import { SwiperSlide } from "swiper/react";
import tw, { styled } from "twin.macro";
import { withFeaturedImageContent } from "./withFeaturedImageContent";

const Swiper = lazy(
  () => import(/* webpackChunkName: "swiper" */ "@components/Swiper/Swiper"),
);
SwiperCore.use([Pagination]);

const Wrapper = tw(StyledContainer)`
  relative max-w-[1440px] mx-auto
`;
const ContentWrapper = tw.div`
  h-full flex items-center py-mini bg-white
`;
const Content = styled.div`
  ${tw`mx-auto max-w-[500px] px-mini py-maxi`}
  .rte {
    p {
      ${tw`opacity-70`}
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      ${tw`text-center md:text-left`}
    }
  }
`;
const Logo = tw.div`
  absolute max-w-[272px] w-full bottom-1/2 right-1/2 transform translate-x-1/2 translate-y-1/2 z-10 hidden md:block
`;

const FeaturedImageContent = withFeaturedImageContent(
  ({ sections, logo, onClickImage, styles, background = "light" }) => (
    <Container
      styles={styles}
      legacy={!styles?.length}
      background={background}
      data-component-type="section-featured-image-content"
    >
      {sections && (
        <Wrapper>
          <Logo>
            <Image image={logo.src} alt={logo.alt} ratio="1/1" />
          </Logo>
          {sections?.map((section) => (
            <ImageContent
              key={section?.image?.asset?.id}
              image={section?.image}
              imageLink={section?.imageLink}
              onClickImage={onClickImage}
              reverse={section?.reverse}
            >
              {section?.contents && (
                <ContentWrapper>
                  {section?.contents?.length > 1 ? (
                    <Suspense fallback={<></>}>
                      <Swiper
                        observer={true}
                        observeParents={true}
                        spaceBetween={0}
                        slidesPerView={1}
                        pagination={{ clickable: true }}
                        lazy={true}
                        preloadImages={false}
                      >
                        {section?.contents.map((content, index) => (
                          <SwiperSlide
                            key={`image-content-swiper-slide-${index}`}
                          >
                            <Content data-testid="content">{content}</Content>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </Suspense>
                  ) : (
                    <Content data-testid="section-content">
                      {section?.contents[0]}
                    </Content>
                  )}
                </ContentWrapper>
              )}
            </ImageContent>
          ))}
        </Wrapper>
      )}
    </Container>
  ),
);

export default FeaturedImageContent;
